<template>
  <div>
    <v-card-text>
      <v-row align="center">
        <v-col cols="12" md="3">
          <label>{{ $t('reviews.place') }}</label>
          <v-text-field v-model="searchInputValue" prepend-inner-icon="$magnify" outlined dense single-line hide-details="auto" />
        </v-col>
        <v-col cols="12" md="2" offset-md="7" class="d-flex justify-end">
          <v-btn v-if="!isArchive" color="primary" depressed @click="addRoad" class="ml-auto">
            {{ $t('fleet.roads.addRoad') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <data-table
      ref="Roads"
      :headers="headers"
      endpoint="/road/getroad"
      :additionalParams="{ vehicleId: vehicleId, showArchived: isArchive }"
      :search="searchInputValue"
      serverPagination
    >
      <template v-slot:item.actions="{ item }">
        <v-menu bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list class="pa-0">
            <v-list-item link @click="showDetails(item)">
              <v-list-item-title>
                {{ $t('common.details') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isArchive" link @click="searchReload(item)">
              <v-list-item-title>
                {{ $t('fleet.roads.searchReloadFromRoad') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="isArchive"  link @click="copyRoad(item)">
              <v-list-item-title>
                {{ $t('fleet.roads.copyRoad') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isArchive"  link @click="showArchiveDialog(item)">
              <v-list-item-title>
                {{ $t('common.archive') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item v-if="!isArchive"  link @click="editRoad(item)">
              <v-list-item-title>
                {{ $t('common.edit') }}
              </v-list-item-title>
            </v-list-item>
            <v-list-item  link @click="showDeleteDialog(item)">
              <v-list-item-title>
                {{ $t('common.delete') }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </data-table>
      <ConfirmDialog
      v-model="archiveDialog"
      :title="$t('fleet.roads.archiveConfirm')"
      @confirm="archiveRoad(true)"
      @close="closeArchiveDialog"/>
      <ConfirmDialog
      v-model="deleteDialog"
      :title="$t('fleet.roads.deleteConfirm')"
      @confirm="archiveRoad(false)"
      @close="closeArchiveDialog"/>
      <RoadsDetailsDialog ref="roadsDetailsDialog" />
      </div>
  </template>

<script>
import Service from '@/services'
import ConfirmDialog from '@/components/ConfirmDialog'
import RoadsDetailsDialog from '../dialogs/RoadDetailsDialog.vue'
import {
  DATETIME
} from '@/types/filter-value-types'
import { convertFilters } from '@/utils/market'
import {
  MAX,
  MIN
} from '@/types/condition-types'

export default {
  name: 'Roads',
  props: {
    isArchive: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  components: {
    RoadsDetailsDialog,
    ConfirmDialog
  },
  data () {
    return {
      loading: false,
      showNewRoad: false,
      archiveDialog: false,
      deleteDialog: false,
      selectedRoad: null,
      searchInputValue: ''
    }
  },
  computed: {
    vehicleId () {
      return this.$route.params.id
    },
    headers () {
      const result = [
        { text: this.$t('fleet.roads.firstLoading'), sortable: false, value: 'firstLoading' },
        { text: this.$t('fleet.roads.lastUnloading'), sortable: false, value: 'lastUnloadng' },
        { text: this.$t('fleet.roads.pointsCount'), sortable: false, value: 'pointsCounter' }
      ]
      result.push({
        text: '',
        align: 'end',
        width: '75',
        value: 'actions',
        sortable: false
      })

      return result
    }
  },
  methods: {
    showDetails (item) {
      this.$refs.roadsDetailsDialog.open(item.id)
    },
    showArchiveDialog (item) {
      this.selectedRoad = item
      this.archiveDialog = true
    },
    showDeleteDialog (item) {
      this.selectedRoad = item
      this.deleteDialog = true
    },
    async archiveRoad (archiveOnly) {
      this.loading = true
      try {
        await Service.delete('road/delete', { roadId: this.selectedRoad.id, archiveOnly: archiveOnly })
        this.refresh()
        this.$emit('roadArchived')
      } catch (e) {
      } finally {
        this.loading = false
      }
      this.closeArchiveDialog()
    },
    editRoad (item) {
      this.$router.push({ name: 'EditRoad', params: { id: this.vehicleId, roadId: item.id } })
    },
    copyRoad (item) {
      this.$router.push({ name: 'CopyRoad', params: { id: this.vehicleId, roadId: item.id } })
    },
    closeArchiveDialog () {
      this.archiveDialog = false
      this.deleteDialog = false
      this.selectedRoad = null
    },
    async addRoad () {
      this.loading = true
      try {
        const { data } = await Service.get('road/getroad', { vehicleId: this.vehicleId })
        if (data.count > 5) {
          await this.$store.dispatch('setErrorNotification', this.$t('fleet.roads.roadsLimit'))
          return
        }
      } catch (e) {
      } finally {
        this.loading = false
      }
      this.$router.push({ name: 'AddRoad', params: { id: this.vehicleId } })
    },
    refresh () {
      this.$refs.Roads.getData()
    },
    async searchReload (item) {
      if (!item || !item.id) return

      this.loading = true

      try {
        // Pobierz szczegóły trasy
        const { data: roadDetails } = await Service.get('road/GetDetails', {
          roadId: item.id
        })

        if (!roadDetails || !roadDetails.places || roadDetails.places.length === 0) {
          await this.$store.dispatch('setErrorNotification', 'Brak punktów na trasie')
          return
        }

        // Przygotuj filtry dat
        const dateFrom = {
          type: MIN,
          name: 'Start',
          valueType: DATETIME,
          value: roadDetails.places[0].dateTime
        }
        const dateTo = {
          type: MAX,
          name: 'Start',
          valueType: DATETIME,
          value: roadDetails.places[roadDetails.places.length - 1].dateTime
        }

        // Rozdziel punkty na załadunki i rozładunki
        const loadingPlaces = JSON.parse(JSON.stringify(roadDetails.places.filter(x => x.type === 0)))
        const unloadingPlaces = JSON.parse(JSON.stringify(roadDetails.places.filter(x => x.type === 1)))

        // Utwórz conditions
        const conditions = {
          minStart: dateFrom,
          maxStart: dateTo,
          locations: {
            type: 17,
            loadingPlaces: loadingPlaces.map(i => ({
              ...i.location
            })),
            unloadingPlaces: unloadingPlaces.map(i => ({
              ...i.location
            }))
          }
        }

        // Przekonwertuj filtry
        const filters = convertFilters(this.$store.getters['market/orderType'], conditions)

        // Utwórz filtr dla pojazdu
        const { data: filterId } = await Service.post('Filter/CreateForVehicle', {
          vehicleId: this.vehicleId,
          conditions: filters.conditions,
          isReload: true
        })

        // Przekieruj do widoku doładunków
        this.$router.push({
          name: 'ReloadsFilter',
          params: {
            id: filterId
          }
        })
      } catch (e) {
        console.error('Error creating reload filter:', e)
        await this.$store.dispatch('setErrorNotification', 'Błąd podczas tworzenia filtra doładunków')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.stateChange {
  color: var(--v-stateChange);
}
.active {
  color: var(--v-primary);
}
</style>
